import React from 'react';
import './NitaSurveyAnalytics.css';

const FEEDBACK_LABELS = {
  liked_best: 'Liked best',
  improvement: 'Improvement ideas',
  favorite_session: 'Favourite session',
  additional_comments: 'Extra comments',
};

function Bars({ entries, fillClass, denom }) {
  if (!entries || entries.length === 0) {
    return <p style={{ color: '#666', fontSize: '0.85rem' }}>No data yet.</p>;
  }
  const max = Math.max(...entries.map((e) => e.count), 1);
  return (
    <div>
      {entries.map((entry) => (
        <div key={entry.name} className="nita-bar-row">
          <div title={entry.label || entry.name} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {entry.label || entry.name}
          </div>
          <div className="nita-bar-track">
            <div
              className={`nita-bar-fill ${fillClass || ''}`}
              style={{ width: `${(entry.count / max) * 100}%` }}
            />
          </div>
          <div className="nita-bar-value">
            {entry.count}{denom ? ` / ${denom}` : ''}
          </div>
        </div>
      ))}
    </div>
  );
}

function daysEntries(breakdown) {
  if (!breakdown) return [];
  return Object.entries(breakdown)
    .map(([name, count]) => ({ name, count, label: `${name} day${name === '1' ? '' : 's'}`, sort: Number(name) }))
    .sort((a, b) => a.sort - b.sort);
}

export default function NitaSurveyAnalytics({ analytics }) {
  if (!analytics) return null;

  const {
    total = 0,
    avg_days_attended: avgDays = 0,
    days_breakdown: daysBreakdown = {},
    outcome_breakdown: outcomeBreakdown = {},
    named_count: namedCount = 0,
    feedback_counts: feedbackCounts = {},
  } = analytics;

  const days = daysEntries(daysBreakdown);
  const feedbackEntries = Object.keys(FEEDBACK_LABELS).map((key) => ({
    name: key,
    label: FEEDBACK_LABELS[key],
    count: feedbackCounts[key] || 0,
  }));
  const outcomeEntries = Object.entries(outcomeBreakdown)
    .map(([name, count]) => ({ name, count, label: name.replace(/_/g, ' ') }))
    .sort((a, b) => b.count - a.count);

  return (
    <div className="card nita-survey-analytics">
      <h3>NITA National ICT Week — Feedback Analytics</h3>

      <div className="grid grid-4" style={{ marginBottom: '1rem' }}>
        <div className="analytics-stat">
          <div className="stat-value">{total}</div>
          <div className="stat-label">Total Responses</div>
        </div>
        <div className="analytics-stat">
          <div className="stat-value">{avgDays ? avgDays.toFixed(1) : '—'}</div>
          <div className="stat-label">Avg Days Attended</div>
        </div>
        <div className="analytics-stat">
          <div className="stat-value">{namedCount}</div>
          <div className="stat-label">Gave Their Name</div>
        </div>
        <div className="analytics-stat">
          <div className="stat-value">{feedbackCounts.liked_best || 0}</div>
          <div className="stat-label">Shared Highlights</div>
        </div>
      </div>

      <div className="nita-section">
        <h4>Days Attended</h4>
        <Bars entries={days} fillClass="nita-bar-fill-days" />
      </div>

      <div className="nita-section">
        <h4>Feedback Coverage (responses with an answer)</h4>
        <Bars entries={feedbackEntries} fillClass="nita-bar-fill-feedback" denom={total} />
      </div>

      <div className="nita-section">
        <h4>Call Outcomes</h4>
        <div className="nita-breakdown-badges">
          {outcomeEntries.length === 0 ? (
            <span style={{ color: '#666', fontSize: '0.85rem' }}>No data yet.</span>
          ) : (
            outcomeEntries.map((entry) => (
              <span key={entry.name} className="badge badge-neutral">
                {entry.label}: {entry.count}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
